import { render } from "./TrainingGroupStatusComponent.vue?vue&type=template&id=132bd402&scoped=true"
import script from "./TrainingGroupStatusComponent.vue?vue&type=script&lang=js"
export * from "./TrainingGroupStatusComponent.vue?vue&type=script&lang=js"

import "./TrainingGroupStatusComponent.vue?vue&type=style&index=0&id=132bd402&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132bd402"]])

export default __exports__